// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { GiftingProposalProjectionFragment } from '../../../modules/gifting/proposal/graphql/GiftingProposalProjection.fragment.generated';
import { gql } from '@apollo/client';
import { GiftingProposalProjectionFragmentDoc } from '../../../modules/gifting/proposal/graphql/GiftingProposalProjection.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetGiftProjectedWealthQueryVariables = Types.Exact<{
  params: Types.GiftingProposalClientProjectionParams;
}>;


export type GetGiftProjectedWealthQuery = { __typename?: 'Query', giftingProposalClientProjections: Array<(
    { __typename?: 'GiftingProposalProjections' }
    & GiftingProposalProjectionFragment
  )> };

export const Operations = {
  Query: {
    GetGiftProjectedWealth: 'GetGiftProjectedWealth' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetGiftProjectedWealthDocument = gql`
    query GetGiftProjectedWealth($params: GiftingProposalClientProjectionParams!) {
  giftingProposalClientProjections(params: $params) {
    ...GiftingProposalProjection
  }
}
    ${GiftingProposalProjectionFragmentDoc}`;

/**
 * __useGetGiftProjectedWealthQuery__
 *
 * To run a query within a React component, call `useGetGiftProjectedWealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGiftProjectedWealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGiftProjectedWealthQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetGiftProjectedWealthQuery(baseOptions: Apollo.QueryHookOptions<GetGiftProjectedWealthQuery, GetGiftProjectedWealthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGiftProjectedWealthQuery, GetGiftProjectedWealthQueryVariables>(GetGiftProjectedWealthDocument, withFetchPolicyContext(options));
      }
export function useGetGiftProjectedWealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGiftProjectedWealthQuery, GetGiftProjectedWealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGiftProjectedWealthQuery, GetGiftProjectedWealthQueryVariables>(GetGiftProjectedWealthDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetGiftProjectedWealthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGiftProjectedWealthQuery, GetGiftProjectedWealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGiftProjectedWealthQuery, GetGiftProjectedWealthQueryVariables>(GetGiftProjectedWealthDocument, withFetchPolicyContext(options));
        }
export type GetGiftProjectedWealthQueryHookResult = ReturnType<typeof useGetGiftProjectedWealthQuery>;
export type GetGiftProjectedWealthLazyQueryHookResult = ReturnType<typeof useGetGiftProjectedWealthLazyQuery>;
export type GetGiftProjectedWealthSuspenseQueryHookResult = ReturnType<typeof useGetGiftProjectedWealthSuspenseQuery>;
export type GetGiftProjectedWealthQueryResult = Apollo.QueryResult<GetGiftProjectedWealthQuery, GetGiftProjectedWealthQueryVariables>;